import { initVueConfig } from '@commons/config'
import { routes } from '@main/routes/index'
import baseStore from '@main/store/index'

document.addEventListener('DOMContentLoaded', () => {
  const Vue = initVueConfig(routes, baseStore)
  Vue.$mount('#main-app')
})